export const EmailReplyToLevel = {
  CENTRAL: 'CENTRAL',
  DOCUMENT_TYPE: 'DOCUMENT_TYPE',
  USER: 'USER',
};

export const EmailReplyToLevelField = [
  { label: 'Központi', value: EmailReplyToLevel.CENTRAL },
  { label: 'Bizonylattípus', value: EmailReplyToLevel.DOCUMENT_TYPE },
  { label: 'Felhasználó', value: EmailReplyToLevel.USER },
];
